// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1H6Tp","left":"StickyBox_left__1as86","right":"StickyBox_right__26A8d"};